module.exports = __webpack_public_path__ + "static/media/notification@2x.b6b66efc.png";